import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";

const IndentModal = ({ showModal, closeModal, branch, onSelectItem }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const pageSize = 10;

  useEffect(() => {
    if (showModal) {
      fetchItems();
    }
  }, [showModal, currentPage, searchTerm]);

  const fetchItems = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/search_items", {
        params: {
          branchcode: branch,
          page: currentPage,
          limit: pageSize,
          searchTerm: searchTerm
        }
      });

      setItems(response.data.items || []);
      setTotalPages(response.data.totalPages || 1);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
    setLoading(false);
  };

  const handleSelectItem = (item) => {
    onSelectItem(item);
    closeModal();
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  if (!showModal) return null;

  return (
    <div className="modal-item">
      <div className="modal-content-item">
        <button className="modal-close-item" onClick={closeModal}>×</button>
        <h3 className="modal-title-item">Add Store Requisition Item</h3>

        {/* Search Section */}
        <div className="search-filter">
          <p>Search Code | Name:</p>
          <input
            type="text"
            className="search-input"
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1); // reset to first page
            }}
            placeholder="Type to search item..."
          />
        </div>

        {/* Results Table */}
        <div className="search-results">
          <table>
            <thead>
              <tr>
                <th>Item Code</th>
                <th>Item Name</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="3">Loading...</td></tr>
              ) : items.length > 0 ? (
                items.map((item) => (
                  <tr key={item.itemmaster_code}>
                    <td>{item.itemmaster_code}</td>
                    <td>{item.itemmaster_name}</td>
                    <td>
                      <button
                        className="select-btn"
                        onClick={() => handleSelectItem(item)}
                      >
                        Select
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan="3">No results found</td></tr>
              )}
            </tbody>
          </table>

          {/* Pagination */}
          <div className="pagination-bar-item">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              ‹ Prev
            </button>
            <span>Page {currentPage} of {totalPages}</span>
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next ›
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndentModal;
